import { BoMItemRow } from 'model/Project/BoMItemRow'
import { SelectedFilter } from 'store/Project/ProjectTypes'

export function applySelectedFilter(
  filter: SelectedFilter,
  row: BoMItemRow,
): boolean {
  if (!filter?.selectedPointers?.length) {
    return true
  }

  return filter.selectedPointers.some((pointer) => pointer.id === row.id)
}
